module.exports = __webpack_public_path__ + "1e659942089063d2a03e32e40de362a6.svg";


//////////////////
// WEBPACK FOOTER
// ./application/font/SourceSansPro-SemiBoldItalic.svg
// module id = 371
// module chunks = 0